import { get } from './commonFetch';

export enum RegisteredTypes {
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  DOMAIN = 'DOMAIN',
}

export type RegisteredType = keyof typeof RegisteredTypes;

interface DkimAttributes {
  values: Record<string, string>;
}

interface RegisteredItem {
  id: string; // UUID
  accountId: number;
  identity: string; // Email address
  type: RegisteredType;
  isEnabled: boolean;
  isVerified: boolean;
  dkimAttributes: DkimAttributes;
  createdAt: string; // Date: '2022-04-07T16:59:37.837986Z'
  updatedAt: string; // Date: '2022-04-07T20:49:48.297978Z'
}

export type RegisteredEmailsAndDomainsResponse = RegisteredItem[];

export const getRegisteredEmailsAndDomains = (): Promise<RegisteredEmailsAndDomainsResponse> => {
  return get('/api/emailIdentities');
};
